import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './PathChooser.css';

function PathChooser() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [selected, setSelected] = useState(null);

    const handleConfirm = () => {
        if (selected === 'test') {
            localStorage.setItem('vozoly_placement_path', 'test');
            localStorage.setItem('vozoly_onboarding_step', 'placement-test');
            navigate('/onboarding/placement-test');
        } else if (selected === 'beginner') {
            localStorage.setItem('vozoly_placement_path', 'beginner');
            localStorage.setItem('vozoly_level', 'A1');
            localStorage.setItem('vozoly_onboarding_step', 'beginner-confirm');
            navigate('/onboarding/beginner-confirm');
        } else if (selected === 'manual') {
            localStorage.setItem('vozoly_placement_path', 'manual');
            localStorage.setItem('vozoly_onboarding_step', 'choose-level');
            navigate('/onboarding/choose-level');
        }
    };

    return (
        <div className="pc-screen">

            <div className="pc-top">
                <button className="pc-back" onClick={() => navigate('/onboarding/goal')}>←</button>
                <div className="pc-step">{t('onboarding.path.step')}</div>
            </div>

            <div className="pc-content">
                <div className="pc-heading">{t('onboarding.path.heading')}</div>
                <div className="pc-subheading">
                    {t('onboarding.path.subheading')}
                </div>

                <div className="pc-cards">

                    <div
                        className={`pc-card pc-card-featured ${selected === 'test' ? 'selected' : ''}`}
                        onClick={() => setSelected('test')}
                    >
                        <div className="pc-card-top">
                            <div className="pc-card-icon-wrap green">
                                <span className="pc-card-icon">🎯</span>
                            </div>
                            <div className={`pc-radio ${selected === 'test' ? 'checked' : ''}`}>
                                {selected === 'test' && <div className="pc-radio-dot"></div>}
                            </div>
                        </div>
                        <div className="pc-recommended-badge">{t('onboarding.path.recommended')}</div>
                        <div className="pc-card-title">{t('onboarding.path.testTitle')}</div>
                        <div className="pc-card-desc">
                            {t('onboarding.path.testDesc')}
                        </div>
                        <div className="pc-card-details">
                            <div className="pc-detail-item">{t('onboarding.path.testDetail1')}</div>
                            <div className="pc-detail-item">{t('onboarding.path.testDetail2')}</div>
                            <div className="pc-detail-item">{t('onboarding.path.testDetail3')}</div>
                            <div className="pc-detail-item">{t('onboarding.path.testDetail4')}</div>
                        </div>
                    </div>

                    <div
                        className={`pc-card pc-card-beginner ${selected === 'beginner' ? 'selected' : ''}`}
                        onClick={() => setSelected('beginner')}
                    >
                        <div className="pc-card-top">
                            <div className="pc-card-icon-wrap amber">
                                <span className="pc-card-icon">👋</span>
                            </div>
                            <div className={`pc-radio ${selected === 'beginner' ? 'checked' : ''}`}>
                                {selected === 'beginner' && <div className="pc-radio-dot"></div>}
                            </div>
                        </div>
                        <div className="pc-card-title">{t('onboarding.path.beginnerTitle')}</div>
                        <div className="pc-card-desc">
                            {t('onboarding.path.beginnerDesc')}
                        </div>
                        <div className="pc-card-details">
                            <div className="pc-detail-item">{t('onboarding.path.beginnerDetail1')}</div>
                            <div className="pc-detail-item">{t('onboarding.path.beginnerDetail2')}</div>
                        </div>
                    </div>

                    <div
                        className={`pc-card ${selected === 'manual' ? 'selected' : ''}`}
                        onClick={() => setSelected('manual')}
                    >
                        <div className="pc-card-top">
                            <div className="pc-card-icon-wrap purple">
                                <span className="pc-card-icon">📋</span>
                            </div>
                            <div className={`pc-radio ${selected === 'manual' ? 'checked' : ''}`}>
                                {selected === 'manual' && <div className="pc-radio-dot"></div>}
                            </div>
                        </div>
                        <div className="pc-card-title">{t('onboarding.path.manualTitle')}</div>
                        <div className="pc-card-desc">
                            {t('onboarding.path.manualDesc')}
                        </div>
                        <div className="pc-card-details">
                            <div className="pc-detail-item">{t('onboarding.path.manualDetail1')}</div>
                            <div className="pc-detail-item">{t('onboarding.path.manualDetail2')}</div>
                        </div>
                    </div>

                </div>

                <div className="pc-note">
                    {t('onboarding.path.note')}
                </div>

            </div>

            <div className="pc-footer">
                <button
                    className="pc-confirm-btn"
                    disabled={!selected}
                    onClick={handleConfirm}
                >
                    {selected === 'test' && `${t('onboarding.path.startTest')} →`}
                    {selected === 'beginner' && `${t('onboarding.path.startBeginner')} →`}
                    {selected === 'manual' && `${t('onboarding.path.chooseLevel')} →`}
                    {!selected && t('onboarding.path.chooseHow')}
                </button>
            </div>

        </div>
    );
}

export default PathChooser;